import { STORE_MODULE_NAME } from "./objectTypeStoreModule";

export default function useObjectType() {

  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {
    fetchDataUrl,
  }
}
